import Logger from 'utils/logging'
import { Character } from 'types/account'
import client, { UserServiceClientResponse } from '../client'

export async function getCharacters(token: string): Promise<UserServiceClientResponse<{characters: Character[]}>> {
    // Only call the service if token is set, else just return false
    if (!token) return { success: false, errorCode: 'no-token' }

    console.log(
        'Getting characters with token:',
        token ? 'token-exists' : 'no-token'
    )

    return client({
        url: `/info/characters`,
        headers: {
            Authorization: `Bearer ${token}`,
            'Access-Control-Allow-Origin': '*',
        },
        method: 'get',
    })
        .then((result) => {
            if (result?.data?.success) {
                return result.data
            }
            return { success: false, errorCode: 'no-characters' }
        })
        .catch((error) => {
            // TODO, review, sentry logging?
            console.error('Error fetching characters:', error)
            Logger.captureNetworkException(
                error,
                'info/characters',
                'user.info.characters'
            )
            return error
        })
}
